// @flow
import React, { useContext } from 'react';
import { DeleteRenderer } from '@components/views/grid-utils/renderers';
import { SPStreamingProjectContext } from '@streaming-projects/sp-page/contexts/SPStreamingProjectContext';
import { FRONT_END_DISPLAY_NAMES } from '@streaming-projects/enums';
import { SPClusterLinkingWorkloadDeleteWarningModal } from '@streaming-projects/workloads/cluster-linking-workloads/delete/SPClusterLinkingWorkloadDeleteWarningModal';

export const SPClusterLinkingWorkloadDeleteRenderer = ({ data }) => {
  const spStreamingProjectData = useContext(SPStreamingProjectContext);
  return (
    <DeleteRenderer>
      {(isDeleteModalOpen, setDeleteModalOpen) => {
        return (
          <SPClusterLinkingWorkloadDeleteWarningModal
            clusterLinkingWorkloadId={data[FRONT_END_DISPLAY_NAMES.WORKLOAD_ID]}
            clusterLinkingWorkloadName={data[FRONT_END_DISPLAY_NAMES.WORKLOAD_NAME]}
            clusterLinkingWorkloadResourceId={data[FRONT_END_DISPLAY_NAMES.RESOURCE_ID]}
            isOpen={isDeleteModalOpen}
            onClose={() => setDeleteModalOpen(false)}
            spVersion={spStreamingProjectData?.sp?.version}
          />
        );
      }}
    </DeleteRenderer>
  );
};
